export enum OrganisationHeirarchyType {
  Parent = 'parent',
  Child = 'child',
}
